/**
 * @flow
 */

import React from 'react';
import buildGTM from 'react-google-tag-manager';


//-----------------------------------------------------------------------------
// Google Tag Manager
//-----------------------------------------------------------------------------

type DefaultProps = {
  additionalEvents: Object,
  dataLayerName: string,
  scriptId: string
};

type Props = DefaultProps & {
  gtmId: string
};

class GoogleTagManager extends React.Component<DefaultProps, Props, void> {
  static defaultProps: DefaultProps = {
    additionalEvents: {},
    dataLayerName: 'dataLayer',
    scriptId: 'react-google-tag-manager-gtm'
  };

  componentDidMount() {
    const gtm = buildGTM({
      id: this.props.gtmId,
      additionalEvents: this.props.additionalEvents,
      dataLayerName: this.props.dataLayerName
    });

    if (!document.querySelector(`script[src='//www.googletagmanager.com/gtm.js?id=${this.props.gtmId}']`)) {
      const script = document.createElement('script');
      script.innerHTML = gtm.scriptAsHTML().replace(/<\/?script>/g, '');
      const body = document.body;
      if (body) {
        body.appendChild(script);
      }
    }
  }

  render() {
    const gtm = buildGTM({
      id: this.props.gtmId,
      additionalEvents: this.props.additionalEvents,
      dataLayerName: this.props.dataLayerName
    });

    return gtm.noScriptAsReact();
  }
}

export default GoogleTagManager;



// WEBPACK FOOTER //
// ./src/components/google-tag-manager.js